import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { PsychologicalPriceStrategy } from '@/lib/graphql/generated/graphql';

interface ApplyPsychoPricesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Called with the chosen strategy when a strategy action is clicked. */
  onSelectStrategy: (strategy: PsychologicalPriceStrategy) => void;
}

/**
 * Confirmation dialog letting the user pick a psychological-pricing strategy
 * (comma vs round) before recomputing "choose" prices. Shared by the bulk-edit
 * floating menu and the anomalies sidebar so both offer the same strategies.
 */
export const ApplyPsychoPricesDialog: React.FC<
  ApplyPsychoPricesDialogProps
> = ({ open, onOpenChange, onSelectStrategy }) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('components.bulk_edit_sidebar.apply_psycho_prices_modal_title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              'components.bulk_edit_sidebar.apply_psycho_prices_modal_confirmation'
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('general.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => onSelectStrategy(PsychologicalPriceStrategy.Comma)}
          >
            {t(
              'components.bulk_edit_sidebar.apply_psycho_prices_modal_strat_2_cta'
            )}
          </AlertDialogAction>
          <AlertDialogAction
            onClick={() => onSelectStrategy(PsychologicalPriceStrategy.Round)}
          >
            {t(
              'components.bulk_edit_sidebar.apply_psycho_prices_modal_strat_1_cta'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
